// The wallet as the sidebar shows it: the balance, when it resets, and how full it is against
// a month's grant. The empty account shows the same box in its header.
import { shortDate } from '@/lib/format';
import type { CreditsDto } from '@/lib/queries';

export function CreditsMeter({
  credits,
  grant,
  trial,
  onBuy,
}: {
  credits: CreditsDto | null;
  grant: number;
  /** No plan has started yet, so what is here is the trial pack. */
  trial: boolean;
  /** Opens the credits sheet: packs on the card on file, from right here. */
  onBuy?: () => void;
}) {
  // A pack can push the wallet over a month's grant: the bar is simply full.
  const pct = credits ? Math.min(100, Math.round((credits.balance / Math.max(1, grant)) * 100)) : 0;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 7,
        padding: '10px 12px',
        borderRadius: 11,
        background: 'var(--bg)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, fontSize: 12 }}>
        <span style={{ fontWeight: 700 }}>Credits</span>
        <span style={{ color: '#777' }}>
          {credits?.balance ?? 0}
          {credits?.resetsAt
            ? ` · +${grant} on ${shortDate(credits.resetsAt)}`
            : trial
              ? ' · trial pack'
              : ''}
        </span>
      </div>
      <div
        style={{ height: 4, borderRadius: 99, background: 'rgba(0,0,0,.08)', overflow: 'hidden' }}
      >
        <span
          style={{
            display: 'block',
            width: `${pct}%`,
            height: '100%',
            borderRadius: 99,
            background: '#111',
            transition: 'width .5s',
          }}
        />
      </div>
      {onBuy && (
        <button
          type="button"
          onClick={onBuy}
          style={{
            alignSelf: 'flex-start',
            border: 0,
            background: 'none',
            padding: 0,
            fontSize: 11.5,
            fontWeight: 700,
            color: 'var(--accent-dark)',
            textDecoration: 'underline',
            textUnderlineOffset: 2,
            cursor: 'pointer',
          }}
        >
          Buy more
        </button>
      )}
    </div>
  );
}
